import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';

import { AngularMaterialCommonModule } from '@app/shared/angular-material/angular-material-common.module';

import { NavigationItem } from '../../navigation-components.model';
import { HeaderService } from '../header.service';

@Component({
  selector: 'app-profile-menu',
  templateUrl: './profile-menu.component.html',
  styleUrls: ['./profile-menu.component.scss'],
  imports: [CommonModule, AngularMaterialCommonModule]
})
export class ProfileMenuComponent {
  @Input() isProfileOpen: boolean;
  @Input() nameInitials: string;
  @Input() navigationList: NavigationItem[];

  constructor(private headerService: HeaderService) {}

  toggleProfileVisibility(): void {
    this.headerService.toggleProfileVisibility(this.isProfileOpen);
  }

  handleProfileNavigationItemAction(item: NavigationItem) {
    this.headerService.handleProfileNavigationItemAction(item);
  }
}
